import getMuiTheme from "material-ui/styles/getMuiTheme";
// import * as muiColors from "material-ui/styles/colors";

export const SPARDA_ORANGE = "#ea7018";
export const SPARDA_BLUE = "#005fa6";
export const SPARDA_DARK_BLUE = "#102648";
export const LIGHT_BLUE = "#c3d5f0";
export const MARGIN_BIG = 40;
export const MARGIN = 20;
export const HEADER_GRADIENT_LIGHT = "#7ea3cf";
export const HEADER_GRADIENT_DARK = "#416a96";
export const ACTION_BUTTON_WIDTH = 200;
export const MAX_APP_WIDTH = 900;

const muiTheme = getMuiTheme({
    palette: {
        primary1Color: SPARDA_BLUE,
        primary2Color: SPARDA_ORANGE
    },
    datePicker: {
        selectColor: SPARDA_BLUE,
        headerColor: SPARDA_BLUE
    },
});

export default muiTheme;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/muiTheme.ts